export default function clientMiddleware(client) {
  return ({ dispatch, getState }) => {
    return (next) => (action) => {
      if (typeof action === "function") {
        return action(dispatch, getState);
      }

      const { promise, types, ...rest } = action;
      if (!promise) {
        return next(action);
      }

      window.resetTimeout = true;

      const [REQUEST, SUCCESS, FAILURE] = types;
      next({ ...rest, type: REQUEST });

      const actionPromise = promise(client, getState());
      actionPromise
        .then((result) => next({ ...rest, result: result.data, type: SUCCESS }))
        .catch((error) => {
          console.error("MIDDLEWARE ERROR:", error);
          return next({ ...rest, message: error.message, type: FAILURE });
        });

      return actionPromise;
    };
  };
}
